import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TokenStorageServiceCliente } from 'src/app/services/api/TokenStorageServiceCliente';


declare let $: any;

@Component({
  selector: 'app-footer-sucursal-ecomerce',
  templateUrl: './footer-sucursal-ecomerce.component.html',
  styleUrls: ['./footer-sucursal-ecomerce.component.css']
})
export class FooterSucursalEcomerceComponent implements OnInit{
  @ViewChild('myModal')
  myModal!: ElementRef;
ocultar:boolean=false;
constructor(

  private router:Router,
  private tokenStorage: TokenStorageServiceCliente,

){


}

ngOnInit(): void {
  
}


OnCerrarDialogo(){
  this.ocultar=false ;
}

OnAbrirDialogo(){
this.ocultar=true ;

  $(this.myModal.nativeElement).modal('show'); 
}


OnLoginCiente(){

  $(this.myModal.nativeElement).modal('hide'); 
  if (this.tokenStorage.getToken()==null) {
    
    this.router.navigateByUrl('/login-cliente/2');

  }else {

    this.router.navigateByUrl('/cambio');
  }

}



}
